import { Driver } from "./driver";

 export class IShift {
  id: number;
  date: Date | null;
  shiftAsrDriverID: number | null;
  shiftNightDriverID: number | null;
   datePersian: string;

   date_dayNumber1: number;
   date_dayNumber2: number;
   driver1: Driver;
   driver2: Driver;
   driver1Name: string;
   driver1Code: string;
   driver2Code: string;
   driver2Name: string;
   monthNumber1: number;
   monthNumber2: number;
   dayWeekName: string;
   avatarAsr: string;
   avatarNight: string;
   constructor(data?: any) {
     if (data) {
       this.id = data.id;
       this.date = data.date;
       this.shiftAsrDriverID = data.shiftAsrDriverID;
       this.shiftNightDriverID = data.shiftNightDriverID;
       this.datePersian = data.datePersian;
       this.date_dayNumber1 = data.date_dayNumber1;
       this.date_dayNumber2 = data.date_dayNumber2;
       this.driver1 = data.driver1;
       this.driver2 = data.driver2;
       this.driver1Name = data.driver1Name;
       this.driver1Code = data.driver1Code;
       this.driver2Code = data.driver2Code;
       this.driver2Name = data.driver2Name;
       this.monthNumber1 = data.monthNumber1;
       this.monthNumber2 = data.monthNumber2;
       this.dayWeekName = data.dayWeekName;
       this.avatarAsr = data.avatarAsr;
       this.avatarNight = data.avatarNight;
     }
   }


   public getShiftName(driverID: number): string  {
     if (this.shiftAsrDriverID == driverID)
       return 'عصر';
     else if (this.shiftNightDriverID == driverID)
       return 'شب';
       return '';
   }
}

 
